import { render, staticRenderFns } from "./GrupoCompra.vue?vue&type=template&id=01276ef2&scoped=true"
import script from "./GrupoCompra.vue?vue&type=script&lang=js"
export * from "./GrupoCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01276ef2",
  null
  
)

export default component.exports